import React from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import useCurrentUser from "../hooks/useCurrentUser";
import { useContext } from "react";
import { ColorContext } from "../context/ColorContext";

import axios from 'axios';

import Avatar from "react-avatar";

import logo from "../images/fractal-logo-white.png";

// Navigation bar at the top of the page, contains links to pages users are permitted
// to access

/**
 * Navigation bar for the top of the page
 * Checks to see if the user is a staff member and displays the appropriate links
 * @returns
 */
const Topbar = (props) => {
  const user = useCurrentUser();
  const { blue, white } = useContext(ColorContext);

  const handleLogout = () => {
    axios
      .get('/api/logout', { withCredentials: true }) // Add withCredentials option
      .then(() => {
        window.location.href = '/'; // redirect the user to the home page or any other desired page
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div id="topbar">
      <Navbar.Brand id="Brand">
        <a href="/explore"><img src={logo} id="topbar-logo" alt="The FRACTAL project logo. The word fractal is displayed in lowercase, white, sans serif font."></img></a>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav"></Navbar.Toggle>
      {user ? (
          <div id = "topbar-links">
            <div id = "topbar-left-side">
              {/* <div id = "lesson-link" className = {props.isLessonPage ? "active-page" : ""}><a href="/lessons">Lessons</a></div> */}
              <div id = "explore-link" className = {props.isExplorePage ? "active-page" : ""}><a href="/explore">Explore</a></div>
              {user.is_staff ? (
                  <div className = {props.isAdminPage ? "active-page" : ""}><a href="/admin">Admin</a></div>
              ) : null}
            </div>
            <div id = "topbar-right-side">
              <div id = "topbar-avatar-link" className="justify-content-end" style={{ width: "100%" }}>
                {user && (
                  <Nav id = "topbar-avatar">
                    <Avatar 
                      // If user name has been changed between
                      // window reloads, use new name
                      name={
                        props.mostUpdatedName ?
                        props.mostUpdatedName :
                        user.first_name
                      } 
                      round={true} 
                      size="50" 
                      color={blue} 
                      fgColor={white} />
                  </Nav>
                )}
                <div id="topbar-dropdown-options">
                  {/* Only show classroom page to teachers */}
                  {user.is_staff && !user.is_superuser && 
                    <div><a href="/classroom">My Classes</a></div>
                  }
                  <div><a href="/profile">My Profile</a></div>
                  <div><a id = "logout-option" onClick={handleLogout}>Logout</a></div>
                </div>
              </div>
            </div>
          </div>
      ) : null}
    </div>
  );
};

export default Topbar;
